import { AccPermission } from "@/accountability/models";
import { FileLinkIcon } from "@/components/atoms/icons";

import { IGIREMenuItem } from "../../models/router.types";
import { PathNamekAppsRoutes, PathNamekRoutes } from "../../constants";

export const accMenuItems: IGIREMenuItem[] = [
  {
    label: "Rendiciones",
    icon: <FileLinkIcon />,
    data: PathNamekAppsRoutes.ACCOUNTABILITY,
    align: "start",
    permission: {
      must: [
        AccPermission.EMPLOYEES_MODULE,
        AccPermission.CATEGORY_MODULE,
        AccPermission.PROGRAM_MODULE,
        AccPermission.SETTLEMENT_MODULE,
        AccPermission.CONFIG,
      ],
      exhaustive: false,
    },
    items: [
      {
        label: "Rendiciones",
        url: `/#/${PathNamekAppsRoutes.ACCOUNTABILITY}/${PathNamekRoutes.RENDITION}`,
        permission: {
          must: AccPermission.SETTLEMENT_MODULE,
        },
      },
      {
        label: "Asociados",
        url: `/#/${PathNamekAppsRoutes.ACCOUNTABILITY}/${PathNamekRoutes.EMPLOYEE}`,
        permission: {
          must: AccPermission.EMPLOYEES_MODULE,
        },
      },
      {
        label: "Categorías",
        url: `/#/${PathNamekAppsRoutes.ACCOUNTABILITY}/${PathNamekRoutes.CATEGORIES}`,
        permission: {
          must: AccPermission.CATEGORY_MODULE,
        },
      },
      {
        label: "Programas",
        url: `/#/${PathNamekAppsRoutes.ACCOUNTABILITY}/${PathNamekRoutes.PROGRAMS}`,
        permission: {
          must: AccPermission.PROGRAM_MODULE,
        },
      },
      {
        label: "Configuración",
        url: `/#/${PathNamekAppsRoutes.ACCOUNTABILITY}/${PathNamekRoutes.CONFIGURATION}`,
        permission: {
          must: AccPermission.CONFIG,
        },
      },
    ],
  },
];
